import React from 'react';
import { Box } from '@mui/material';
import HeaderProfile from '../../components/header_Profile/header_Profile.index';
import DirectPharmacyDispenseForm from './DirectPharmacyDispenseForm';

/**
 * DirectPharmacyDispense - Main page component for direct pharmacy dispense
 *
 * Shows all prescribed drugs directly on the dispense page without requiring
 * a separate selection step. Users can:
 * 1. Select a pharmacy store
 * 2. View all prescribed drugs for the patient
 * 3. Select items to dispense
 * 4. Proceed to dispense directly
 */
const DirectPharmacyDispense = () => (
  <>
    <HeaderProfile />
    <Box sx={{ mx: 2, mt: 2 }}>
      <DirectPharmacyDispenseForm />
    </Box>
  </>
);

export default DirectPharmacyDispense;
